import React, { createContext, useContext, useState, useEffect } from 'react';
import axios from 'axios';
import toast from 'react-hot-toast';

const AuthContext = createContext();

export const useAuth = () => {
  const context = useContext(AuthContext);
  if (!context) {
    throw new Error('useAuth must be used within an AuthProvider');
  }
  return context;
};

// Configuration axios — Cloudflare Pages / same-origin prod / local dev
const resolveApiBase = () => {
  const raw = typeof process.env.REACT_APP_API_URL === 'string' ? process.env.REACT_APP_API_URL.trim() : '';
  if (raw !== '') return raw.replace(/\/$/, '');
  if (typeof window !== 'undefined' && window.location.hostname === 'localhost') {
    return 'http://localhost:5002/api';
  }
  return '/api';
};
axios.defaults.baseURL = resolveApiBase();
axios.defaults.withCredentials = true;

export const AuthProvider = ({ children }) => {
  // Always authenticated with admin user
  const [user] = useState({ 
    id: 'admin123',
    name: 'Administrateur',
    email: 'admin@formation.dz',
    role: 'admin'
  });
  
  // Always set token
  const [token] = useState('auto-auth-token');

  // Configure axios interceptor for token
  useEffect(() => {
    axios.defaults.headers.common['Authorization'] = `Bearer ${token}`;
  }, [token]);

  // Login function is a no-op that always succeeds
  const login = async () => {
    return { success: true };
  };

  // Logout function is a no-op
  const logout = () => {
    // No actual logout needed
  };

  const updateUser = () => {
    // No-op since user is fixed
  };

  const value = {
    user,
    loading: false,
    login,
    logout,
    updateUser,
    isAuthenticated: true, // Always authenticated
    isAdmin: true, // Always admin
    isStaff: true, // Always staff
  };

  return <AuthContext.Provider value={value}>{children}</AuthContext.Provider>;
};